import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookText } from 'lucide-react';
import Card from '../components/Card';
import { DOCS } from '../docs';
import { DOC_MAX_WIDTH } from '../docs/docBits';

// Documentation index (doc-277). Driven entirely off the registry in
// src/docs/index.js — never a hardcoded list, so a new doc shows up here by
// adding one entry there.

export default function Docs() {
  return (
    <div className="canvas-inner animate-fade-in">
      <div style={{ maxWidth: DOC_MAX_WIDTH }}>
        <div className="page-header">
          <div>
            <h1 className="page-title">Documentation</h1>
            <div className="page-subtitle">
              How Docket&apos;s surfaces work, for the people who use them.
            </div>
          </div>
        </div>

        {DOCS.length === 0 ? (
          <Card>
            <div style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-base)' }}>
              No documentation has been published yet.
            </div>
          </Card>
        ) : (
          DOCS.map((doc) => (
            <Card key={doc.slug} style={{ marginBottom: 12 }}>
              <Link
                to={`/docs/${doc.slug}`}
                className="row"
                style={{
                  gap: 12,
                  alignItems: 'flex-start',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
              >
                <BookText
                  className="w-4 h-4"
                  style={{ color: 'var(--icon-secondary)', flexShrink: 0, marginTop: 3 }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 'var(--font-size-lg)',
                      fontWeight: 'var(--font-weight-medium)',
                      color: 'var(--text-primary)',
                    }}
                  >
                    {doc.title}
                  </div>
                  <div
                    style={{
                      marginTop: 4,
                      fontSize: 'var(--font-size-sm)',
                      lineHeight: 1.55,
                      color: 'var(--text-secondary)',
                    }}
                  >
                    {doc.summary}
                  </div>
                </div>
                {/* The row is flex-start so the leading BookText stays on the
                    title line; the trailing arrow belongs to the whole row, so
                    it opts out and centers against the full content block
                    (doc-303) rather than riding the title with a nudge. */}
                <ArrowRight
                  className="w-4 h-4"
                  style={{ color: 'var(--icon-secondary)', flexShrink: 0, alignSelf: 'center' }}
                />
              </Link>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
